import { lazy } from "react";

const KEY = "cs_chunk_reload";

// After a republish, an open page may ask for old code files: retry once, then reload the page once.
export const lazyRetry = (factory) => lazy(() => factory()
  .catch(() => new Promise((r) => setTimeout(r, 1500)).then(factory))
  .then((m) => { sessionStorage.removeItem(KEY); return m; })
  .catch((e) => {
    if (!sessionStorage.getItem(KEY)) {
      sessionStorage.setItem(KEY, "1");
      window.location.reload();
      return new Promise(() => {});
    }
    throw e;
  }));
